import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loading: {
		id: 'skeletons.common.loading',
		defaultMessage: 'Loading',
		description: 'Alt text of skeleton image',
	},
});
export default messages;
